import { Content } from 'antd/es/layout/layout'
import Breadcrumbs from 'components/Breadcrumbs'
import useEntities from 'hooks/useEntities'
import useFetchEntity from 'hooks/useFetchEntity'
import useOrganization from 'hooks/useOrganization'
import icons from 'utils/icons'

const ExtrasPlayer = () => {
  const { organization } = useOrganization();
  const entities = useEntities();
  const entity = entities.Organization;
  
  const showExtras = organization?.showExtras === true || organization?.showExtras === 1;
  const { data: orgData, isLoading } = useFetchEntity(
    showExtras ? entity?.name : null,
    showExtras ? organization?.organizationId : null,
    '',
    showExtras ? { onlyAttributes: ['extrasHtml'] } : {}
  );

  const extrasHtml = orgData?.extrasHtml;
  const hasExtrasHtml = extrasHtml && extrasHtml.trim() !== '';

  return (
    <Content className="m-3 desktop:m-4">
      <Breadcrumbs items={[{ title: 'Extras', icon: icons.Information }]} />
      {isLoading ? null : !hasExtrasHtml ? (
        <div className="w-full max-w-2xl mx-auto px-2 text-center text-gray-600 text-base">
          Your extras and gifts coming soon.
        </div>
      ) : (
        <div 
          className="w-full mx-auto px-2"
          dangerouslySetInnerHTML={{ __html: extrasHtml }}
        />
      )}
    </Content>
  )
}

export default ExtrasPlayer 

